import { render, staticRenderFns } from "./ScreenEdit.vue?vue&type=template&id=22908cc7&scoped=true&"
import script from "./ScreenEdit.vue?vue&type=script&lang=ts&"
export * from "./ScreenEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22908cc7",
  null
  
)

export default component.exports